<template>
  <div>
    <b-row class="align-items-center">
      <b-col cols="2" lg="4" class="d-flex align-items-center">
        <b-navbar-toggle target="v-b-toggle sidebar-right"></b-navbar-toggle>
      </b-col>
      <b-col cols="6">
        <h4 class="pt-1 pe-3 text-center res-tablet">
          {{ config.title }}
        </h4>
      </b-col>
      <b-col cols="4" lg="8" class="ps-4 d-flex">
        <router-link to="/" class="main-logo text-start">
          <img :src="config.logoAddress" class="nav-logo" width="55%" />
        </router-link>
      </b-col>
    </b-row>

    <b-sidebar id="sidebar-right" right shadow>
      <div class="px-3">
        <b-row>
          <b-col class="m-0 pl-0 py-0 text-center" cols="12">
            <router-link to="/">
              <img :src="config.secondLogoAddress" width="35%" />
            </router-link>
            <h4 class="pt-3 mb-0">
              {{ config.title }}
            </h4>
          </b-col>
          <b-col
            class="my-4 py-2 pl-0 pe-8"
            dir="rtl"
            cols="12"
            v-for="mMenu in menus.filter((menus) => menus.name === 'Main')"
            :key="mMenu.id"
          >
            <ul class="menu-items px-4">
              <li
                class="p-fs-l"
                v-for="menu in mMenu.children.filter(
                  (mMenu) => mMenu.children !== null
                )"
                :key="menu.id"
              >
                <h5 class="p-fs-l text-p-muted">
                  <button
                    v-b-toggle.collapse-3
                    class="text-p-first p-fw-bold pe-0"
                  >
                    <span class="text-p-muted ms-3">
                      {{ menu.text }}
                    </span>
                    <b-icon icon="chevron-down" class="mt-1"></b-icon>
                  </button>
                </h5>
                <b-collapse id="collapse-3" class="dropDown-menu">
                  <div
                    class="d-flex align-items-center me-2"
                    v-for="child in menu.children"
                    :key="child.id"
                  >
                    <b-icon
                      icon="circle-fill"
                      scale="0.4"
                      class="text-p-readonly"
                    ></b-icon>
                    <router-link
                      :to="setDynamicLink(child.link)"
                      v-if="child.isDynamic"
                    >
                      <h5 class="text-p-first me-1 mb-0">{{ child.text }}</h5>
                    </router-link>
                    <router-link :to="setStaticLink(child.link)" v-else>
                      <h5 class="text-p-first me-1 mb-0">{{ child.text }}</h5>
                    </router-link>
                  </div>
                </b-collapse>
              </li>
              <li
                v-for="menu in mMenu.children.filter(
                  (mMenu) => mMenu.children === null
                )"
                :key="menu.id"
              >
                <h5 class="p-fs-l mt-4">
                  <button
                    v-b-toggle.collapse-1
                    class="text-p-muted p-fw-bold pe-0"
                    @click="routeLink(menu)"
                  >
                    {{ menu.text }}
                  </button>
                </h5>
              </li>
            </ul>
          </b-col>
          <b-col>
            <!-- change language button -->
            <div class="language-menu" v-if="multiLnaguageCheck === 1">
              <div @click="languageModal = true">
                <span v-if="language === 'En'">
                  <img
                    src="@/assets/images/flags/en-lang-flag.png"
                    class="img-fluid ms-2"
                    width="30px"
                    height="30px"
                  />
                  {{ label.menu.langEn }}
                </span>
                <span v-else-if="language === 'Fr'">
                  <img
                    src="@/assets/images/flags/fr-lang-flag.png"
                    class="img-fluid ms-2"
                    width="30px"
                    height="30px"
                  />
                  {{ label.menu.langFr }}
                </span>
                <span v-else-if="language === 'Ar'">
                  <img
                    src="@/assets/images/flags/ar-lang-flag.png"
                    class="img-fluid ms-2"
                    width="30px"
                    height="30px"
                  />
                  {{ label.menu.langAr }}
                </span>
                <span v-else-if="language === 'Tr'">
                  <img
                    src="@/assets/images/flags/tr-lang-flag.png"
                    class="img-fluid ms-2"
                    width="30px"
                    height="30px"
                  />
                  {{ label.menu.langTr }}
                </span>
                <span v-else>
                  <img
                    src="@/assets/images/flags/fa-lang-flag.png"
                    class="img-fluid ms-2"
                    width="30px"
                    height="30px"
                  />
                  {{ label.menu.langFa }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-sidebar>

    <!-- language modal -->
    <b-modal
      dir="rtl"
      v-model="languageModal"
      content-class="p-border-3"
      centered
      hide-header
      hide-footer
      size="lg"
    >
      <b-container fluid>
        <b-row class="justify-content-center my-2">
          <b-col class="text-end pe-1 mb-3 d-flex">
            <button
              class="ps-closeModalBtn"
              @click="languageModal = false"
              v-b-tooltip.hover
              title="بستن پنجره"
            >
              <b-icon icon="x" scale="1.5"></b-icon>
            </button>
            <h3 class="pe-5 pt-1">
              {{ label.caption.chooseLang }}
            </h3>
          </b-col>
          <b-col
            cols="12"
            class="align-self-center py-0 px-5"
            @click="changeLanguage('Fa')"
          >
            <img
              src="@/assets/images/flags/fa-lang-flag.png"
              class="img-fluid ms-1"
              width="25px"
              height="25px"
            />
            {{ label.menu.langFa }}
          </b-col>
          <b-col
            cols="12"
            class="align-self-center py-0 px-5"
            @click="changeLanguage('En')"
          >
            <img
              src="@/assets/images/flags/en-lang-flag.png"
              class="img-fluid ms-1"
              width="25px"
              height="25px"
            />
            {{ label.menu.langEn }}
          </b-col>
          <b-col
            cols="12"
            class="align-self-center py-0 px-5"
            @click="changeLanguage('Fr')"
          >
            <img
              src="@/assets/images/flags/fr-lang-flag.png"
              class="img-fluid ms-1"
              width="25px"
              height="25px"
            />
            {{ label.menu.langFr }}
          </b-col>
          <b-col
            cols="12"
            class="align-self-center py-0 px-5"
            @click="changeLanguage('Ar')"
          >
            <img
              src="@/assets/images/flags/ar-lang-flag.png"
              class="img-fluid ms-1"
              width="25px"
              height="25px"
            />
            {{ label.menu.langAr }}
          </b-col>
          <b-col
            cols="12"
            class="align-self-center py-0 px-5"
            @click="changeLanguage('Tr')"
          >
            <img
              src="@/assets/images/flags/tr-lang-flag.png"
              class="img-fluid ms-1"
              width="25px"
              height="25px"
            />
            {{ label.menu.langTr }}
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/plugins/StaticLabels.js";

export default {
  name: "TheResponsiveSidebar",
  components: {},
  data() {
    return {
      label,
      languageModal: false,
      multiLnaguageCheck: process.env.VUE_APP_MULTI_LANGUAGE,
    };
  },
  computed: {
    ...mapGetters({
      menus: "baseX/menus",
      config: "baseX/config",
      language: "selectedLanguage",
      token: "panelX/token",
    }),
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    changeLanguage(item) {
      localStorage.setItem("PCMSClientLanguage", item);
      this.$store.commit("setLanguage", item);
      this.languageModal = false;
      this.$router.push("/");
    },
    setDynamicLink(item) {
      return "/page" + item;
    },
    setStaticLink(item) {
      if (item.startsWith("/", 0)) {
        return item;
      } else {
        return "/" + item;
      }
    },
    routeLink(menu) {
      if (menu.link.indexOf("https") === 0 || menu.link.indexOf("http") === 0) {
        window.open(menu.link, "_blank");
      } else {
        this.$router.push(menu.link);
      }
    },
  },
};
</script>

<style scoped>
.pe-5 {
  flex-direction: column;
}
.py-0 {
  line-height: 40px;
}
</style>
